import styled from 'styled-components';
import { PaginationJumpItemMixin } from '../../mixins/components/PaginationJumpItemMixin';
/**
 * Used by the [`Pagination`](#/More%20components?id=pagination) component to house the
 * "previous" and "next" buttons based on
 * [`PaginationButton`](#/More%20components?id=paginationbutton).
 *
 * @component
 * @since 7.42.0
 */

var PaginationJumpItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "PaginationJumpItem",
  componentId: "c11n-8-64-0__sc-18wdg2l-0"
})(["", ""], PaginationJumpItemMixin);
/** @component */

export default PaginationJumpItem;
export var StyledPaginationJumpItem = PaginationJumpItem;